const alertData = [
    {
        color: 'primary',
        icon: 'mdi-bullseye-arrow'
    },
    {
        color: 'secondary',
        icon: 'mdi-grease-pencil'
    },
    {
        color: 'success',
        icon: 'mdi-check-all'
    },
    {
        color: 'danger',
        icon: 'mdi-block-helper'
    },
    {
        color: 'warning',
        icon: 'mdi-alert-outline'
    },
    {
        color: 'info',
        icon: 'mdi-alert-circle-outline'
    }
];

export { alertData };
